import { WEB_ACTION_SOURCE, WebActionTypes } from './MobileBridgeContext.constants';
import { NavigateToUrlOptionsPayload } from './MobileBridgeContext.types';

const setSourceInPayload = <T>(payload: T): T & { source: typeof WEB_ACTION_SOURCE } => ({
    ...payload,
    source: WEB_ACTION_SOURCE,
});

export const navigateToUrl = (payload: NavigateToUrlOptionsPayload) => ({
    type: WebActionTypes.NAVIGATE_TO_URL,
    payload: setSourceInPayload(payload),
});
